import { GridColDef } from "@mui/x-data-grid";

import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Divider, Menu, MenuItem, Stack } from "@mui/material";
import { CustomDataGrid } from "../../../../components/CustomDataGrid";
import { baseURL } from "../../../../config/api";

export const AllGateways = () => {
  const [loading, setLoading] = useState(true);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [searchTableData, setSearchTableData] = useState<any[]>([]);
  const [totalLength, setTotalLength] = useState<number>(0);

  const [columnFilterAnchorEl, setColumnFilterAnchorEl] = useState<null | HTMLElement>(null);
  const columnFilterOpen = Boolean(columnFilterAnchorEl);
  const initialColumns: GridColDef[] = [
    {
      field: "id",
      headerName: "#",
      flex: 1,
      editable: false,
      sortable: false,
    },
    {
      field: "label",
      headerName: "Label",
      flex: 2,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <Link
            to="/admin/settings/edit-payment-gateways-form"
            state={params.id} className="underline text-[#0000ff]"
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "#",
      headerName: "Adapter",
      flex: 1,
      editable: false,
      sortable: false,
    },
    {
      field: "methods",
      headerName: "Methods",
      type: "number",
      flex: 1,
      editable: false,
      sortable: false,
    },
    {
      field: "isActive",
      headerName: "Active?",
      editable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "testMode",
      headerName: "Test Mode",
      flex: 1,
      editable: false,
      sortable: false,
    },
    {
      field: "order",
      headerName: "Order",
      flex: 1,
      editable: false,
      sortable: false,
    },
  ];
  const [columns, setColumns] = useState<GridColDef[]>(initialColumns);
  const [selectedColumns, setSelectedColumns] = useState(initialColumns?.map(col => col?.headerName));

  const handleColumnFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setColumnFilterAnchorEl(event.currentTarget);
  };
  const handleColumnFilterClose = () => {
    setColumnFilterAnchorEl(null);
  };

  const toggleColumn = (headerName: string) => {
    setSelectedColumns(prev =>
      prev.includes(headerName) ? prev.filter(col => col !== headerName) : [...prev, headerName]
    );
  };

  useEffect(() => {
    const filterCol = initialColumns?.filter(col => selectedColumns?.includes(col?.headerName));
    setColumns(filterCol);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedColumns])

  const toggleAll = () => {
    if (selectedColumns?.length === initialColumns?.length) {
      setSelectedColumns([]);
    } else {
      setSelectedColumns(initialColumns?.map(col => col?.headerName));
    }
  };

  useEffect(() => {
    emptySearchApiCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel])

  const emptySearchApiCall = () => {
    setLoading(true);
    fetch(`${baseURL}paymentGateways`)
      .then((res) => res.json())
      .then((data) => {
        const result = data?.map((item: any) => {
          return {
            ...item,
            isActive: item.isActive ? "Yes" : "No",
            testMode: item.testMode ? "Yes" : "No",
          };
        })

        setSearchTableData(result);
        setTotalLength(data?.count);
        setLoading(false);
      })
      .catch(error => {
        setSearchTableData([]);
        setTotalLength(0);
        setLoading(false);
      });
  }

  return (
    <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
      <div className="w-full bg-white p-4 rounded-md">
        <div className={`flex justify-between items-center p-4 border-b border-gray-300`}>
          <div className="flex items-center gap-1.5">

            <h2 className={`text-lg font-semibold text-secondary`}>Payment Gateways</h2>

            <div >
              <button
                className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid border-gray-300`}
                aria-controls={columnFilterOpen ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={columnFilterOpen ? 'true' : undefined}
                onClick={handleColumnFilterClick}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <span className={`text-secondary text-[14px] font-medium`}>Columns</span>
                  <span className={`material-symbols-outlined text-[18px] font-lighttext-secondary`}>
                    filter_alt
                  </span>
                </Stack>
              </button>

              <Menu
                id="basic-menu"
                anchorEl={columnFilterAnchorEl}
                open={columnFilterOpen}
                onClose={handleColumnFilterClose}
                slotProps={{
                  paper: {
                    sx: {
                      width: 170,
                      maxHeight: 300,
                      backgroundColor: "white"
                    }
                  }
                }}
              >
                <div className="flex items-center gap-2 px-[16px] py-[6px] w-full">
                  <input
                    type="checkbox"
                    className="form-checkbox cursor-pointer"
                    checked={selectedColumns?.length === initialColumns?.length ? true : false}
                    onClick={toggleAll}
                  />
                  <span className={`text-secondary font-medium text-[12px]`}>Select All</span>
                </div>
                <Divider className="w-full" />
                {
                  initialColumns?.map((column, index) => (
                    <>
                      <MenuItem
                        key={index}
                        sx={{
                          fontSize: "12px",
                          marginBlock: "0px",
                          "&: hover": {
                            cursor: "default"
                          }
                        }}
                      >
                        <div className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            className="form-checkbox cursor-pointer"
                            checked={selectedColumns.includes(column?.headerName)}
                            onChange={() => toggleColumn(column?.headerName || "")}
                          />
                          <span className={`text-secondary font-medium`}>{column?.headerName}</span>
                        </div>

                      </MenuItem>
                      <Divider className="w-full" />
                    </>

                  ))
                }
              </Menu>
            </div>
          </div>
        </div>

        <CustomDataGrid
          filteredRows={searchTableData}
          columns={columns?.map(col => ({
            ...col,
            headerClassName: "white",
          }))}
          loading={loading}
          totalLength={totalLength}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
        />
      </div>
    </div>
  )
}